import React from 'react'
import "./src/assets/layout.css"

import { AlertsProvider, ALERT_DOMAIN } from '@ndlib/component-library'
import { MergedProvider } from './src/components/Providers'
import TrackClicks from './src/components/trackClicks'

declare global {
  interface Window {
    dataLayer: any[]
  }
}

export const wrapRootElement = ({ element }) => {
  return (
    <AlertsProvider domain={ALERT_DOMAIN.LIBRARY}>
      <MergedProvider testMode={false} element={<TrackClicks>{element}</TrackClicks>} />
    </AlertsProvider>
  )
}

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  return true
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  try {
    const dataLayer = window.dataLayer || []
    const clickEvent = dataLayer.find(event => event.event === 'clickTracking')

    const clickText = clickEvent ? clickEvent.clickText : null
    const clickUrl = clickEvent ? clickEvent.clickUrl : null

    window.dataLayer.push({
      event: 'gatsby-route-change',
      route: location.pathname,
      prevRoute: prevLocation ? prevLocation.pathname : null,
      clickText: clickText,
      clickUrl: clickUrl,
    })
  } catch (error) {
    console.log('window datalayer is unavailable')
    console.log(error)
  }
}
